(ns livefeed.feed-reactions
  (:require [reagent.core :as reagent :refer [atom with-let]]
            [livefeed.state :as state]))

(def reactions (atom ()))

(defn ^:private top [{:keys [y]}]
  (str (* 100 y) "%"))

(defn ^:private right [{:keys [y wavelength waveheight offset-x offset-y]}]
  (-> (Math/sin (+ (* y wavelength) offset-y))
      (* waveheight)
      (+ 40 offset-x)
      (str "px")))

(defn ^:private size [{:keys [y]}]
  (str (+ 20 (* 20 y)) "px"))

(defn ^:private opacity [{:keys [y]}]
  (+ 0.5 (* 0.5 y)))

(defn ^:private random-num [from to]
  (+ from (rand (- to from))))

(defn animate [ms {:keys [y speed] :as r}]
  (when (< -0.1 y)
    (update r :y - (* ms speed))))

(defn new-reaction [reaction-id]
  (let [{:keys [src name]} (get @state/emojis reaction-id)]
    {:src        src
     :name       name
     :y          (random-num 1 1.3)
     :id         (gensym "feed-reaction")
     :speed      (random-num 0.0003 0.0004)
     :wavelength (random-num 12 20)
     :waveheight (random-num 10 30)
     :offset-y   (random-num 0 (* 2 Math/PI))
     :offset-x   (random-num -10 10)}))

(def max-reactions 4)

(defn ^:private ceil [i]
  (long (Math/ceil i)))

(defn ^:private logistic-curve [x]
  (- (/ 2 (+ 1 (Math/exp (* -0.1 x)))) 1))

(defn add-reactions! [reaction-counts]
  (let [total (reduce + (vals reaction-counts))
        actual-total (* max-reactions (logistic-curve total))
        factor (/ actual-total total)
        new-reactions (apply concat (for [[reaction-id n] reaction-counts]
                                      (repeatedly (ceil (* n factor)) #(new-reaction reaction-id))))]
    (swap! reactions into new-reactions)))

(defn add-reaction-at! [reaction-id pos]
  (let [r (-> (new-reaction reaction-id)
              (assoc :offset-x (- pos 40)
                     :offset-y 0
                     :y 1))]
    (swap! reactions conj r)))

(defn now []
  (.getTime (js/Date.)))

(defn component []
  (with-let [animation-id (clojure.core/atom nil)
             from (clojure.core/atom (now))
             animate-all (fn animate-all []
                           (let [to (now)
                                 ms (- to @from)]
                             (swap! reactions #(when (seq %)
                                                 (take 20 (keep (partial animate ms) %))))
                             (reset! from to)
                             (reset! animation-id (js/window.requestAnimationFrame animate-all))))
             _ (animate-all)]
    [:<>
     (for [r @reactions]
       ^{:key (:id r)}
       [:img.yle-livefeed__reaction
        {:aria-hidden "true"
         :src   (:src r)
         :style {:top     (top r)
                 :right   (right r)
                 :width   (size r)
                 :height  (size r)
                 :opacity (opacity r)}}])]
    (finally
      (js/window.cancelAnimationFrame @animation-id))))

